import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Card, CardBody, CardFooter, CardHeader,
    Col,
    Container,
    Row
} from 'reactstrap';

// import PropertySearchBar from "../../../components/controls/search/PropertySearchBar";
import OwnerListingRow from './OwnerListingRow';
import PolyUtil from "../../../util/PolyUtil";
import {handleResendVerifyEmail} from "../actions/owner";
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";

class OwnerApplications extends Component {
    state = {
        searchTerm: ''
    };

    onSearch = (value) => {
        this.setState({searchTerm: value});
    };

    content = () => {
        const {properties, email_verified} = this.props;
        const no_applications_properties = PolyUtil.validArr(properties) && properties.filter(function (prop) {
            const counts = prop.active_listing.applied_roommate_group_counts;
            return counts.new + counts.pending + counts.accepted === 0;
        });
        // const search = this.state.searchTerm;
        return email_verified ? (
            <div>
                {/*<PropertySearchBar onSearch={this.onSearch}/>*/}

                <Container className="mt-4">
                    <Row>
                        <Col>
                            <h2 className="mb-0">Applications</h2>
                        </Col>
                    </Row>
                    <hr/>
                    {
                        PolyUtil.validArr(properties) && properties.sort((a, b) => {
                            const ac = a.active_listing.applied_roommate_group_counts;
                            const bc = b.active_listing.applied_roommate_group_counts;
                            const aTotal = ac.new + ac.pending;
                            const bTotal = bc.new + bc.pending;
                            // return (PolyUtil.getPropertyStreetAddress(a) > PolyUtil.getPropertyStreetAddress(b)) ? 1
                            //     : -1;
                            return (aTotal) > (bTotal) ? -1 : (aTotal < bTotal) ? 1 : 0;
                        }).filter(function (prop) {
                            const counts = prop.active_listing.applied_roommate_group_counts;
                            return counts.new + counts.pending + counts.accepted > 0;
                        }).map(function (property, i) {
                            return (
                                <OwnerListingRow key={i} property={property}/>
                            );
                        })
                    }
                    {
                        no_applications_properties.length > 0 && <div>
                            <h4>Applications not yet received for:</h4>
                            {
                                no_applications_properties.map(function (property, i) {
                                    return (
                                        <h5 key={i}>
                                            <strong><a href={"/listings/" + property.active_listing.apply_key + "/"}
                                                    target="_blank">{PolyUtil.getPropertyStreetAddress(property)}{property.identifier && " (" + property.identifier + ")"}</a></strong>
                                        </h5>
                                    );
                                })
                            }
                        </div>
                    }

                </Container>
            </div>
        ) : (
            <div>
                <Container className="mt-4 justify-content-center">
                    <Row>
                        <Col>
                            <Card>
                                <CardHeader>
                                    <h3 className="text-info">Hmmm...</h3>
                                </CardHeader>
                                <CardBody>
                                    <p>It looks like you haven't verified your email! For privacy reasons, we can't show you tenant applications until you've done this.</p>
                                    <p>Please follow the link in the email that was sent to you when you signed up. If you can't find it, click the button below.</p>
                                </CardBody>
                                <CardFooter>
                                    <AsyncButton task={this.props._handleResendVerifyEmail} color="info" noComplete>Resend Verification Email</AsyncButton>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props, ['properties']) ? this.content() : null;
    }
}

const mapStateToProps = (state) => {
    let properties = [];
    state.owner.properties.forEach(function (property) {
        !!property.active_listing.apply_key && properties.push(property);
    });

    return {
        properties: properties,
        email_verified: state.owner.email_verified
    };
};

const mapDispatchToProps = (dispatch) => ({
    _handleResendVerifyEmail() {
        return dispatch(handleResendVerifyEmail());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnerApplications);



// WEBPACK FOOTER //
// ./src/containers/owner/applications/OwnerApplications.js